export default __webpack_public_path__ + "static/media/arrow-right-black.2628a0a1.svg";